import { render } from "./templates.vue?vue&type=template&id=e95e954c&lang=pug"
import script from "./templates.vue?vue&type=script&lang=js"
export * from "./templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__